'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import Link from 'next/link';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import Image from 'next/image';
import TestimonialTile from 'shared/components/TestimonialTile';
import { Dictionaries, Locale } from 'shared/i18n/i18n-config';
import { getI18nUtils } from 'shared/i18n/i18n-utils';
import useWindowWidth from 'shared/hooks/useWindowWidth';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import useScrollHeight from 'shared/hooks/useScrollHeight';
import CtaBtn from 'shared/components/CtaBtn';
import GeneralContactForm from 'shared/components/GeneralContactForm';
import { buttons, courses, timeline, trainers, academyHappy } from './config';

type Props = {
  dictionary: Partial<Dictionaries>;
  locale: Locale;
};

export default function SynergieAcademy({ locale, dictionary }: Props) {
  const { formatMessage } = getI18nUtils(dictionary);
  const windowWidth = useWindowWidth();
  const scrollHeight = useScrollHeight();
  const onMobile = windowWidth && windowWidth < 992;
  const [visible, setVisible] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);
  const [isVisible, setIsVisible] = useState([false, false, false, false, false]);
  const workingAtLink =
    locale === 'fr'
      ? 'https://www.travaillerchezsynergie.be/fr/happyatsynergie/'
      : 'https://www.werkenbijsynergie.be/nl/happyatsynergie/';

  useEffect(() => {
    if (visible) return;
    if (scrollHeight > 500) setVisible(true);
  }, [scrollHeight, visible]);

  const triggerSequence = useCallback(() => {
    isVisible.forEach((_, i) => {
      setTimeout(() => {
        setIsVisible((prev) => {
          const newVisible = [...prev];
          newVisible[i] = true;
          return newVisible;
        });
      }, i * 500);
    });
  }, [isVisible]);

  useEffect(() => {
    const node = ref.current;
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          triggerSequence();
          observer.unobserve(entry.target);
        }
      },
      { threshold: 1 }
    );
    if (node) observer.observe(node);
    return () => {
      if (node) observer.unobserve(node);
    };
  }, [triggerSequence]);

  return (
    <>
      {/* Floating CTA */}
      <Container>
        <Row className="position-relative">
          <Col lg={{ offset: 3, size: 9 }} className="d-lg-flex justify-content-lg-end">
            <div id="main-cta" className={`floating-button ${visible ? 'visible' : ''} ${scrollHeight > 500 ? 'fixed' : ''}`}>
              <Link href="#contact" className={'btn btn-primary'}>
                <span className={'me-2'}>{formatMessage({ id: 'employers-academy-ctabtn' })}</span>
                <svg height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                  <g fillRule="evenodd">
                    <path
                      fill={'white'}
                      d="m1.1117.02285-.8838.883775 4.7267 4.726525-4.7267 4.7265.8838.883775 5.610525-5.610275z"
                      fillRule="nonzero"
                      transform="translate(.5 .25)"
                    />
                  </g>
                </svg>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
      <div id="synergieacademy">
        {/* Buttons */}
        <Container className="bg-white d-flex justify-content-center py-5 px-0">
          <Row className="w-100 d-flex justify-content-center align-items-center">
            <Col className="d-none d-lg-block me-1">
              <hr className="border-2 opacity-50 text-black" />
            </Col>
            <Col xs={12} lg="auto" className="d-flex justify-content-center">
              <Row className="d-flex align-items-center gx-0 w-100">
                {buttons.map((button, index) => (
                  <Col xs={6} md={4} lg="auto" className="p-1" key={'button-' + index}>
                    <Link href={button.link}>
                      <Button outline className="w-100">
                        {formatMessage({ id: button.name })}
                      </Button>
                    </Link>
                  </Col>
                ))}
              </Row>
            </Col>
            <Col className="d-none d-lg-block ms-1">
              <hr className="border-2 opacity-50 text-black" />
            </Col>
          </Row>
        </Container>
        {/* Daarom is er Synergie Academy */}
        <section id="synergie-academy" className="pt-5 pb-5" style={{ backgroundColor: '#DACFDE' }}>
          <Container>
            <Row>
              <Col xs={12} sm={3} lg={6} align="center">
                <Image
                  className="my-5 mw-100 h-auto"
                  src={'/synergie_academy.png'}
                  alt={'Synergie Academy logo'}
                  width={225}
                  height={225}
                />
              </Col>
              <Col xs={12} sm={9} lg={6} className="d-flex flex-column justify-content-center">
                <h2 className="mb-4">{formatMessage({ id: 'employers-academy-synergie-academy-title' })}</h2>
                <p className="m-0">{formatMessage({ id: 'employers-academy-synergie-academy-intro' })}</p>
              </Col>
            </Row>
          </Container>
        </section>
        {/* Wat onze trajecten je opleveren */}
        <section className="pt-5 pb-5 bg-white">
          <Container>
            <Row>
              <Col sm={7} lg={6} className="d-flex flex-column justify-content-center mb-5 mb-lg-0">
                <h2 className="text-uppercase">{formatMessage({ id: 'employers-academy-synergie-academy-title-2' })}</h2>
                <p>{formatMessage({ id: 'employers-academy-synergie-academy-intro-2' })}</p>
                <ul className="academyList lh-lg">
                  <li>{formatMessage({ id: 'employers-academy-synergie-academy-bullet1' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-synergie-academy-bullet2' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-synergie-academy-bullet3' })}</li>
                </ul>
                <p>{formatMessage({ id: 'employers-academy-synergie-academy-outro' })}</p>
                <Link href="#contact">
                  <CtaBtn className="cta red" type="button">
                    {formatMessage({ id: 'employers-academy-synergie-academy-cta' })}
                  </CtaBtn>
                </Link>
              </Col>
              <Col sm={5} lg={6}>
                <Image
                  src={'/images/academy/academy_image_1.jpg'}
                  alt={'Afbeelding opleveren traject'}
                  className={'mw-100 h-auto'}
                  width={672}
                  height={429}
                />
              </Col>
            </Row>
          </Container>
        </section>
        {/* Testimonial */}
        <section className="pt-5 pb-5 bg-light">
          <Container className="testimonial testimonial-academy mt-lg-4 mb-lg-4">
            <TestimonialTile
              quote={formatMessage({ id: 'employers-academy-quote' })}
              name={formatMessage({ id: 'employers-academy-quote-person-name' })}
              imagePath="/images/academy/academy_image_2.jpg"
              position={formatMessage({ id: 'employers-academy-quote-job-function' })}
              quoteColor="var(--bs-warning)"
            />
          </Container>
        </section>
        {/* Onze aanpak in 5 stappen */}
        <section id="approach" className="pt-5 pb-5 bg-white">
          <Container>
            <Row>
              <Col lg={5}>
                <div className="my-2 my-lg-5 pe-md-5">
                  <h2 className="text-uppercase mb-4">{formatMessage({ id: 'employers-academy-approach-title' })}</h2>
                  <p>{formatMessage({ id: 'employers-academy-approach-intro' })}</p>
                  <Image
                    className="object-fit-contain square w-100 h-100 mt-5"
                    src={'/images/academy/academy_image_3.jpg'}
                    alt={'Afbeelding onze aanpak'}
                    width={1024}
                    height={819}
                  />
                </div>
              </Col>
              <Col lg={7}>
                <div ref={ref} className="mt-5 h-100">
                  {timeline.map((item, index) => (
                    <div className={`timeline-item ${isVisible[index] ? 'visible' : ''}`} key={'item-' + index}>
                      <p className="timeline-title m-0 fw-semibold fs-5">{formatMessage({ id: item.title })}</p>
                      <p className="timeline-description m-0 pb-5">{formatMessage({ id: item.description })}</p>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* Opleidingen en trajecten die werken */}
        <section className="pt-5 pb-5" style={{ backgroundColor: '#DACFDE' }}>
          <Container className="mt-4 mb-4 d-flex flex-column justify-content-center">
            <Row>
              <h2 className="text-center mb-3">{formatMessage({ id: 'employers-academy-courses-title' })}</h2>
              <p className="text-center mb-5 mx-auto" style={{ maxWidth: '730px' }}>
                {formatMessage({ id: 'employers-academy-courses-description' })}
              </p>
            </Row>
            <Row>
              {courses.map(({ title, description, icon }, index) => (
                <Col key={title + description} lg={3} md={6} xs={12}>
                  {icon}
                  <h3 className="h3 mt-3 mt-lg-5 mb-3">
                    {formatMessage({ id: 'employers-academy-courses-item-' + index + '-title' })}
                  </h3>
                  <p className="mb-5 mb-lg-0">
                    {formatMessage({ id: 'employers-academy-courses-item-' + index + '-description' })}
                  </p>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        {/* Een greep uit ons aanbod */}
        <section id="offer" className="pt-5 pb-5 bg-white">
          <Container>
            <Row>
              <h2 className="text-uppercase mb-5">{formatMessage({ id: 'employers-academy-our-offering-title' })}</h2>
            </Row>
            <Row>
              <Col className="d-flex flex-column justify-content-center">
                <ul className="academyList lh-lg">
                  <li>{formatMessage({ id: 'employers-academy-our-offering-bullet-1' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-our-offering-bullet-2' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-our-offering-bullet-3' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-our-offering-bullet-4' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-our-offering-bullet-5' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-our-offering-bullet-6' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-our-offering-bullet-7' })}</li>
                </ul>
              </Col>
              <Col>
                <ul className="academyList lh-lg">
                  <li>{formatMessage({ id: 'employers-academy-our-offering-bullet-8' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-our-offering-bullet-9' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-our-offering-bullet-10' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-our-offering-bullet-11' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-our-offering-bullet-12' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-our-offering-bullet-13' })}</li>
                </ul>
              </Col>
            </Row>
          </Container>
        </section>
        {/* Waarom kiezen voor Synergie Academy? */}
        <section id={'why'} className="pt-5 pb-5 bg-light">
          <Container>
            <Row>
              <Col xs={12} md={6} className="d-flex flex-column justify-content-center mb-3 mb-md-0">
                <h2 className="text-uppercase">{formatMessage({ id: 'employers-academy-why-title' })}</h2>
                <ul className="academyList lh-lg">
                  <li>{formatMessage({ id: 'employers-academy-why-bullet-1' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-why-bullet-2' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-why-bullet-3' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-why-bullet-4' })}</li>
                  <li>{formatMessage({ id: 'employers-academy-why-bullet-5' })}</li>
                </ul>
                <Link href="#approach">
                  <CtaBtn className="cta red" type="button">
                    {formatMessage({ id: 'employers-academy-why-cta' })}
                  </CtaBtn>
                </Link>
              </Col>
              <Col xs={12} md={6}>
                <Image
                  src={'/images/academy/academy_image_4.jpg'}
                  alt={formatMessage({ id: 'employers-academy-why-title' })}
                  className={'mw-100 h-auto'}
                  width={613}
                  height={429}
                />
              </Col>
            </Row>
          </Container>
        </section>
        {/* Trainers met praktijkervaring */}
        <section id="trainers" className="pt-5 pb-5">
          <Container className="mt-4 mb-4 d-flex flex-column justify-content-center">
            <Row>
              <h2 className="text-center mb-3">{formatMessage({ id: 'employers-academy-trainers-title' })}</h2>
              <p className="text-center mb-5 mx-auto">{formatMessage({ id: 'employers-academy-trainers-description' })}</p>
            </Row>
            <Row className={'mx-auto'} style={{ maxWidth: '1040px' }}>
              {trainers
                .filter((trainer) => !(locale === 'nl' && trainer.hideNl))
                .map(({ name, jobTitle, profilePicture }, index) => (
                  <Col key={name + jobTitle} lg={3} md={4} xs={6} className={'mb-2 mb-md-5'}>
                    <div className={'bg-light p-1 p-md-3 mx-1 rounded h-100 text-darkblue border-1 border-gray-300'}>
                      <div className={'rounded overflow-hidden'}>
                        <Image className={'w-100 h-auto'} src={profilePicture} alt={name} width={170} height={170} />
                      </div>
                      <h5 className="mt-3 mb-2">{name}</h5>
                      <p className="mb-5 mb-lg-0">{formatMessage({ id: jobTitle })}</p>
                    </div>
                  </Col>
                ))}
              <Col lg={3} md={4} xs={12} className={'mb-md-5'}>
                <div
                  className={
                    'bg-light mx-1 p-3 rounded h-100 text-darkblue border-1 border-gray-300 d-flex flex-column justify-content-center'
                  }
                >
                  <p className="text-purple">{formatMessage({ id: 'employers-academy-trainers-cta-description' })}</p>
                  <Link href={'#contact'} className="btn btn-primary btn-sm btn-purple">
                    <span className={'me-2 fw-bold'}>{formatMessage({ id: 'employers-academy-trainers-cta' })}</span>
                    <svg height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                      <g fillRule="evenodd">
                        <path
                          fill={'white'}
                          d="m1.1117.02285-.8838.883775 4.7267 4.726525-4.7267 4.7265.8838.883775 5.610525-5.610275z"
                          fillRule="nonzero"
                          transform="translate(.5 .25)"
                        />
                      </g>
                    </svg>
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* Ook intern investeren wij in groei */}
        <section id="happy-synergie" className="pt-5 pb-5 bg-light">
          <Container className="mt-4 mb-4 d-flex flex-column justify-content-center">
            <Row>
              <h2 className="text-center mb-3">{formatMessage({ id: 'employers-academy-happy-title' })}</h2>
              <p className="text-center mb-5 mx-auto">{formatMessage({ id: 'employers-academy-happy-description' })}</p>
            </Row>
            <Row>
              {academyHappy.map(({ description, icon }, index) => (
                <Col key={description} lg={3} md={4} xs={12} className={'text-center'}>
                  <div className={'mb-5'}>{icon}</div>
                  <p className="mb-5 mb-lg-0">{formatMessage({ id: description })}</p>
                </Col>
              ))}
            </Row>
            <Row>
              <div className={'d-flex justify-content-center align-items-center flex-column mt-5'}>
                <h5 className={'mb-4'}>{formatMessage({ id: 'employers-academy-happy-outro' })}</h5>
                <Link href={workingAtLink} target={'_blank'} className="btn btn-primary cta red mx-auto" type="button">
                  <span className={'me-2 fw-bold'}>{formatMessage({ id: 'employers-academy-happy-cta' })}</span>
                  <svg height="12" viewBox="0 0 8 12" width="8" xmlns="http://www.w3.org/2000/svg">
                    <g fillRule="evenodd">
                      <path
                        fill={'white'}
                        d="m1.1117.02285-.8838.883775 4.7267 4.726525-4.7267 4.7265.8838.883775 5.610525-5.610275z"
                        fillRule="nonzero"
                        transform="translate(.5 .25)"
                      />
                    </g>
                  </svg>
                </Link>
              </div>
            </Row>
          </Container>
        </section>
        {/* Interesse? Neem contact op! */}
        <section id="contact" className="pt-5 pb-5 bg-white">
          <Container className="mt-md-5 mb-md-5">
            <Row>
              <Col xs={12} lg={6}>
                <div style={{ maxWidth: '420px' }}>
                  <h2 className="mb-4">{formatMessage({ id: 'employers-academy-form-title' })}</h2>
                  <p>{formatMessage({ id: 'employers-academy-form-description-1' })}</p>
                  <p>
                    {formatMessage(
                      { id: 'employers-academy-form-description-2' },
                      {
                        mailtoLink: <Link href={`mailto:academy@synergiejobs.be`}>academy@synergiejobs.be</Link>,
                      }
                    )}
                  </p>
                  <p>{formatMessage({ id: 'employers-academy-form-description-3' })}</p>
                </div>
              </Col>
              <Col xs={12} lg={6}>
                <Card id="contactForm" className="rounded-0 mb-0">
                  <CardBody>
                    <GeneralContactForm
                      compact={onMobile ? false : true}
                      locale={locale}
                      dictionary={dictionary}
                      submitHandler={setSubmitting}
                      submitting={submitting}
                      confirmationMessage={
                        <div>
                          <h4 className="mb-3">{formatMessage({ id: 'employers-academy-submit-title' })}</h4>
                          <p className="mb-0">{formatMessage({ id: 'employers-academy-submit-message-1' })}</p>
                          <p>{formatMessage({ id: 'employers-academy-submit-message-2' })}</p>
                          <p className="mb-0">{formatMessage({ id: 'employers-academy-submit-message-3' })}</p>
                          <p>{formatMessage({ id: 'employers-academy-submit-message-4' })}</p>
                        </div>
                      }
                      hasMessage={false}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
